<template>
  <div class="bodybody">
    <link
      href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@500;700&display=swap"
      rel="stylesheet"
    />
    <div class="container">
      <div class="wrapper">
        <div class="flexbox">
          <div class="title" >Liquidity Staking</div>
          <img src="../assets/liquid.gif" alt="" />
        </div>

        <div class="content">
          <div class="address" >Address: {{ account }}</div>
          <div class="box" >
            <div class="btn-wrapper">
              <button class="btn" @click="enableWallet">Enable Wallet</button>
            </div>
            <div class="btn-wrapper">
              <a
                class="btn"
                href="https://app.uniswap.org/#/add/0x9b574599822642b04d0ff7e5776df3a06f4540ba/ETH"
                target="_blank"
                >Provide Liquidity</a
              >
            </div>
          </div>

          
          <div class="gridbox">
            <div class="box1 grid" data-aos="zoom-out" data-aos-duration="1000">
              <div class="box2" >
                <span class="title1">Your HODL Balance: </span><br /><br />
                <span class="title2" v-if="account">{{ hodlBalance }}</span>
              </div>
              <div class="box2">
                <span class="title1">Your Liquidity Token Balance: </span
                ><br /><br />
                <span class="title2" v-if="account">{{ lpBalance }}</span>
              </div>
            </div>
          </div>

          <br> <br> 
          <div class="stakingStats">
            <div class="box3" >
              <span class="title1"> Total Staked </span>
              <span class="content">
                {{ lpTotalSupply }} Liquidity Tokens
              </span>
            </div>

            <div class="box3">
              <span class="title1"> Your Share </span>
              <span class="content">
                {{ yourPercent }}%
              </span>
            </div>

            <div class="box3">
              <span class="title1"> Your Reward Rate </span>
              <span class="content">
                {{ rewardRate }} HODL/day
              </span>
            </div>

            <div class="box3">
              <span class="title1"> APY </span>
              <span class="content">
                {{ APY }}%
              </span>
            </div>
          </div>

          <div class="gridbox">
            <div class="box1" data-aos="zoom-out" data-aos-duration="1000">
              <div class="box1 grid">
                <div class="box2">
                  <span class="title1">Your Staked Balance: </span><br /><br />
                  <span class="title2" v-if="account">{{ stakedBalance }}</span>
                </div>
                <div class="box2">
                  <span class="title1">Your Rewards: </span><br /><br />
                  <span class="title2" v-if="account">{{ rewards }}</span>
                </div>
              </div>
              <div class="btn-wrapper">
                <button class="btn" @click="approveLP">Approve</button>
                <button class="btn" @click="stakeLP">Stake All</button>
                <button class="btn" @click="getReward">Claim Rewards</button>
                <button class="btn" @click="exitStaking">Withdraw All</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="statusbox" v-if="status">
      <span class="status">
        {{ status }}
      </span>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";

export default {
  data() {
    return {
      account: "",
      hodlABI: [
        { inputs: [], stateMutability: "nonpayable", type: "constructor" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "spender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "oldCoolDownTime",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "newCoolDownTime",
              type: "uint256",
            },
          ],
          name: "ChangeCoolDownTime",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "oldPercentile",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "newPercentile",
              type: "uint256",
            },
          ],
          name: "ChangeStrongHandPercentile",
          type: "event",
        },
        { anonymous: false, inputs: [], name: "EndGame", type: "event" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "previousOwner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "newOwner",
              type: "address",
            },
          ],
          name: "OwnershipTransferred",
          type: "event",
        },
        { anonymous: false, inputs: [], name: "StartGame", type: "event" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
        },
        {
          inputs: [],
          name: "_burnedSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_coolDownTime",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_gameStarted",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_lastUpdated",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_strongHandPercentile",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
          ],
          name: "allowance",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "account", type: "address" },
          ],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            {
              internalType: "uint256",
              name: "subtractedValue",
              type: "uint256",
            },
          ],
          name: "decreaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "endGame",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "addedValue", type: "uint256" },
          ],
          name: "increaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "name",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "owner",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "renounceOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "coolDownTime", type: "uint256" },
          ],
          name: "setCoolDownTime",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "percentile", type: "uint256" },
          ],
          name: "setStrongHandPercentile",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "startGame",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "symbol",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "sender", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "newOwner", type: "address" },
          ],
          name: "transferOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      hodlAddy: "0x9B574599822642B04d0fF7e5776dF3A06f4540ba",
      lpStakingAddy: "0x1221BE917DAF9c2Ee192b243401aD1B78067A6ed",
      uniV2TokenAddy: "0x79A4C4563A29d49ABf5F67AF2f73BB3D1f0d6Fd6",
      uniV2TokenABI: [
        {
          inputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "constructor",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "spender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "sender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount0",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount1",
              type: "uint256",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
          ],
          name: "Burn",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "sender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount0",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount1",
              type: "uint256",
            },
          ],
          name: "Mint",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "sender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount0In",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount1In",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount0Out",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount1Out",
              type: "uint256",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
          ],
          name: "Swap",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint112",
              name: "reserve0",
              type: "uint112",
            },
            {
              indexed: false,
              internalType: "uint112",
              name: "reserve1",
              type: "uint112",
            },
          ],
          name: "Sync",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
        },
        {
          constant: true,
          inputs: [],
          name: "DOMAIN_SEPARATOR",
          outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "MINIMUM_LIQUIDITY",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "PERMIT_TYPEHASH",
          outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [
            { internalType: "address", name: "", type: "address" },
            { internalType: "address", name: "", type: "address" },
          ],
          name: "allowance",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [{ internalType: "address", name: "", type: "address" }],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [{ internalType: "address", name: "to", type: "address" }],
          name: "burn",
          outputs: [
            { internalType: "uint256", name: "amount0", type: "uint256" },
            { internalType: "uint256", name: "amount1", type: "uint256" },
          ],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "decimals",
          outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "factory",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "getReserves",
          outputs: [
            { internalType: "uint112", name: "_reserve0", type: "uint112" },
            { internalType: "uint112", name: "_reserve1", type: "uint112" },
            {
              internalType: "uint32",
              name: "_blockTimestampLast",
              type: "uint32",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { internalType: "address", name: "_token0", type: "address" },
            { internalType: "address", name: "_token1", type: "address" },
          ],
          name: "initialize",
          outputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "kLast",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [{ internalType: "address", name: "to", type: "address" }],
          name: "mint",
          outputs: [
            { internalType: "uint256", name: "liquidity", type: "uint256" },
          ],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "name",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [{ internalType: "address", name: "", type: "address" }],
          name: "nonces",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
            { internalType: "uint256", name: "deadline", type: "uint256" },
            { internalType: "uint8", name: "v", type: "uint8" },
            { internalType: "bytes32", name: "r", type: "bytes32" },
            { internalType: "bytes32", name: "s", type: "bytes32" },
          ],
          name: "permit",
          outputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "price0CumulativeLast",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "price1CumulativeLast",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [{ internalType: "address", name: "to", type: "address" }],
          name: "skim",
          outputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { internalType: "uint256", name: "amount0Out", type: "uint256" },
            { internalType: "uint256", name: "amount1Out", type: "uint256" },
            { internalType: "address", name: "to", type: "address" },
            { internalType: "bytes", name: "data", type: "bytes" },
          ],
          name: "swap",
          outputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "symbol",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [],
          name: "sync",
          outputs: [],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "token0",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "token1",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: true,
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          constant: false,
          inputs: [
            { internalType: "address", name: "from", type: "address" },
            { internalType: "address", name: "to", type: "address" },
            { internalType: "uint256", name: "value", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          payable: false,
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      lpStakingABI: [
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "reward",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "duration",
              type: "uint256",
            },
          ],
          name: "FarmingStarted",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "previousOwner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "newOwner",
              type: "address",
            },
          ],
          name: "OwnershipTransferred",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "address",
              name: "token",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
          ],
          name: "Recovered",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "user",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "reward",
              type: "uint256",
            },
          ],
          name: "RewardPaid",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "user",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
          ],
          name: "Staked",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "user",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
          ],
          name: "Withdrawn",
          type: "event",
        },
        {
          inputs: [
            { internalType: "address", name: "account", type: "address" },
          ],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "canRecover",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "disableTokenRecovery",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "account", type: "address" },
          ],
          name: "earned",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "enableTokenRecovery",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "exit",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "getReward",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "hodl",
          outputs: [
            { internalType: "contract IERC20", name: "", type: "address" },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "lastTimeRewardApplicable",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "lastUpdateTime",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "owner",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "periodFinish",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "tokenAddress", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "recoverERC20",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "recoverRewardToken",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "recoveryCooldown",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "renounceOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "rewardPerToken",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "rewardPerTokenStored",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "rewardRate",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [{ internalType: "address", name: "", type: "address" }],
          name: "rewards",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "stake",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "reward", type: "uint256" },
            { internalType: "uint256", name: "duration", type: "uint256" },
          ],
          name: "startFarming",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "newOwner", type: "address" },
          ],
          name: "transferOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "unilp",
          outputs: [
            { internalType: "contract IERC20", name: "", type: "address" },
          ],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "unlockTime",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [{ internalType: "address", name: "", type: "address" }],
          name: "userRewardPerTokenPaid",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "withdraw",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      hodlBalance: "",
      lpBalance: 0,
      approveStatus: "",
      fullAccount: "",
      lpFullBalance: "",
      stakedBalance: "",
      status: "",
      rewards: "",
      lpTotalSupply: "",
      yourPercent: '',
      rewardRate: '',
      APY: '',
    };
  },
  methods: {
    async enableWallet() {
      let ethereum = window.ethereum;
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      let account =
        (await accounts[0].substring(0, 6)) +
        "..." +
        accounts[0].substring(19, 24);
      this.account = account;
      this.fullAccount = accounts[0];

      //web3
      var web3 = new Web3(Web3.givenProvider);
      const hodlContract = new web3.eth.Contract(this.hodlABI, this.hodlAddy);
      const uniV2Contract = new web3.eth.Contract(
        this.uniV2TokenABI,
        this.uniV2TokenAddy
      );
      const lpContract = new web3.eth.Contract(
        this.lpStakingABI,
        this.lpStakingAddy
      );

      let hodlbalance = await hodlContract.methods
        .balanceOf(accounts[0])
        .call()
        .then();
      this.hodlBalance = (hodlbalance / 10 ** 18).toFixed(2);

      //getting your univ2 token balance
      let lpBalance = await uniV2Contract.methods.balanceOf(accounts[0]).call();
      this.lpBalance = (lpBalance / 10 ** 18).toFixed(4);
      this.lpFullBalance = lpBalance;

      //getting your univ2 staked balance
      let stakedBalance = await lpContract.methods
        .balanceOf(accounts[0])
        .call();
      this.stakedBalance = (stakedBalance / 10 ** 18).toFixed(4);

      //getting your rewards
      let rewardsBalance = await lpContract.methods.earned(accounts[0]).call();
      this.rewards = (rewardsBalance / 10 ** 18).toFixed(2);

      //getting total univ2 staked supply
      let lpTotalSupply = await lpContract.methods.totalSupply().call();
      this.lpTotalSupply = (lpTotalSupply / 10 ** 18).toFixed(2);

      //calc your share of the pool
      let yourPercent = stakedBalance/lpTotalSupply*100;
      this.yourPercent = yourPercent.toFixed(2);

      //get reward per univ2 token
      let rewardRate = await lpContract.methods.rewardRate().call();//rate per second -- this is total rate
      this.rewardRate = (stakedBalance/lpTotalSupply*(rewardRate*86400/10**18)).toFixed(2);

      //calculating APY
      let data = await fetch('https://api.ethplorer.io/getAddressInfo/0x79A4C4563A29d49ABf5F67AF2f73BB3D1f0d6Fd6?apiKey=freekey').then(res => res.json());
      console.log(data)
      
      let ethBalance = data.tokens[1].balance/(10**18);
      let hodlPrice = data.tokens[1].balance/(data.tokens[0].balance)*(data.ETH.price.rate);
      hodlPrice = hodlPrice.toFixed(2);
      this.APY = (hodlPrice*(rewardRate*86400*365*yourPercent/100/(10**18)/(ethBalance))).toFixed(2);
    },
    async approveLP() {
      var web3 = new Web3(Web3.givenProvider);
      var uniV2Contract = new web3.eth.Contract(
        this.uniV2TokenABI,
        this.uniV2TokenAddy
      );

      let amount = this.convert(10000 * 10 ** 18);

      let approveStatus = await uniV2Contract.methods
        .approve("0x1221BE917DAF9c2Ee192b243401aD1B78067A6ed", amount)
        .send({ from: this.fullAccount });
      if (approveStatus.status == true) {
        this.txStatus("Approved Successfully");
      }
    },
    async stakeLP() {
      var web3 = new Web3(Web3.givenProvider);
      var lpStakingContract = new web3.eth.Contract(
        this.lpStakingABI,
        this.lpStakingAddy
      );

      let amount = this.convert(this.lpFullBalance);

      let stakingStatus = await lpStakingContract.methods
        .stake(amount)
        .send({ from: this.fullAccount });
      if (stakingStatus.status == true) {
        this.txStatus(
          "Staked " + this.lpBalance + " Liquidity Tokens Successfully"
        );
      }
    },
    async getReward() {
      var web3 = new Web3(Web3.givenProvider);
      var lpStakingContract = new web3.eth.Contract(
        this.lpStakingABI,
        this.lpStakingAddy
      );

      let rewardStatus = await lpStakingContract.methods
        .getReward()
        .send({ from: this.fullAccount });
      if (rewardStatus.status == true) {
        this.txStatus("Claim Rewards Successfully");
      }
    },
    async exitStaking() {
      var web3 = new Web3(Web3.givenProvider);
      var lpStakingContract = new web3.eth.Contract(
        this.lpStakingABI,
        this.lpStakingAddy
      );

      let exitStatus = await lpStakingContract.methods
        .exit()
        .send({ from: this.fullAccount });
      if (exitStatus.status == true) {
        this.txStatus("Withdrew Successfully");
      }
    },
    convert(n) {
      var sign = +n < 0 ? "-" : "",
        toStr = n.toString();
      if (!/e/i.test(toStr)) {
        return n;
      }
      var [lead, decimal, pow] = n
        .toString()
        .replace(/^-/, "")
        .replace(/^([0-9]+)(e.*)/, "$1.$2")
        .split(/e|\./);
      return +pow < 0
        ? sign +
            "0." +
            "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
            lead +
            decimal
        : sign +
            lead +
            (+pow >= decimal.length
              ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
              : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
    },
    async txStatus(status) {
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));

      this.status = status;

      await delay(4000);
      this.enableWallet();

      await delay(8000);
      this.status = "";
    },
  },
  mounted() {
    this.enableWallet();
  },
};
</script>

<style lang="scss" scoped>
.bodybody {
  position: relative;

  .statusbox {
    position: absolute;
    top: 5%;
    right: 5%;
    background: white;
    padding: 2em;
    font-family: "Turret Road", cursive;
  }
}

.container {
  background: black;
  padding: 4em 0;
  font-family: "Turret Road", cursive;
}

.wrapper {
  padding: 2em 4em;
  color: white;
  font-family: "Turret Road", cursive;
  display: grid;
  justify-content: center;

  .flexbox {
    display: flex;
    align-items: center;
    margin-bottom: 1em;
    gap: 1em;

    img {
      width: 100px;
    }
  }

  .title {
    font-size: 300%;
    color: white;
  }

  .content {
    .address {
      color: rgb(150, 150, 150);
    }
    display: grid;

    .box {
      padding: 2em 0;
      display: flex;
      gap: 1em;

      .btn-wrapper {
        display: grid;
        justify-items: center;

        .btn {
          padding: 1em;
          background: black;
          color: white;
          border: 1px solid white;
          cursor: pointer;
          font-family: "Turret Road", cursive;
          transition: all 0.3s ease-in-out;
          font-size: 110%;
          letter-spacing: 1px;
          text-decoration: none;

          &:hover {
            background: rgba(255, 255, 255, 0.5);
            color: black;
            font-weight: bold;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }

    .stakingStats {
      padding: 1em 0;
      display: grid;
      grid-gap: 0;
      grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
      

      .box3 {
        display: grid;
        justify-content: center;
        padding: 0.8em;
        grid-gap: 0.5em;

        .title1 {
          color: rgb(150, 150, 150);
          font-size: 180%;
          text-align: center;
        }

        .content {
          font-size: 120%;
          justify-self: center;
          text-align: center;
        }
      }
    }

    .gridbox {
      display: grid;
      grid-gap: 2em;
      grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));

      .box1 {
        background: white;
        padding: 1em;
        border-radius: 5px;

        .title1 {
          color: black;
          letter-spacing: 1px;
        }

        .title2 {
          color: black;
          letter-spacing: 2px;
          font-size: 2em;
          text-align: center;
          display: block;
        }

        .btn-wrapper {
          padding: 1em;
          display: grid;
          gap: 1em;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          justify-items: space-around;

          .btn {
            background: black;
            color: white;
            border: none;
            padding: 1em;
            font-family: "Turret Road", cursive;
            font-weight: bold;
            letter-spacing: 1px;
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            letter-spacing: 3px;
            font-size: 15px;

            &:hover {
              background: rgb(100, 100, 100);
            }

            &:focus {
              outline: none;
            }
          }
        }
      }

      .grid {
        display: grid;
        align-items: center;
        grid-gap: 1em;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
    }
  }
}

@media (max-width: 650px) {
  .wrapper {
    .flexbox {
      .title {
        font-size: 200%;
      }

      img {
        width: 50px;
      }
    }
    .content {
      .gridbox {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      }

      .stakingStats {
        grid-template-columns: repeat(auto-fit,minmax(150px,1fr));
        .box3 {

        .title1 {
          font-size: 110%;
        }

        .content {
          font-size: 80%;
        }
      }
      }
    }
  }
}

@media (max-width: 450px) {
  .wrapper {
    justify-content: center;
    .flexbox {
      .title {
        font-size: 150%;
      }
      img {
        width: 50px;
      }
    }
  }
}
</style>
